import React from 'react'

function Searching() {
    return (

        <div className="py-2 lg:py-4">
            <div className="container mx-auto lg:mb-4">

                <div className="flex justify-center">
                    <div className="lg:w-1/3 lg:px-0 px-5">
                        <div className="bg-white rounded shadow p-5 text-center">
                            <div className="mb-2">
                                <i className="icon icon-search-home w-64 h-64"></i>
                            </div>
                            <h3 className="font-bold text-2xl text-gray-900 mb-4">Searching</h3>
                            <p className="text-gray-600 text-sm mb-2">Please wait while we search our databases for your query.</p>
                            <i className="fas fa-cog fa-spin"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Searching;